export default {"src":"/_next/static/media/water-consumption.a5b6c73e.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};